<template>
  <section class="complementary-info">
    <div>
      <h6 class="subtitle">
        {{ $t('profile.complementaryInformations') }} *
      </h6>
      <p>{{ $t('profile.acceptPromotionalOffers') }}</p>
      <section
        v-if="!minified"
        class="complementary-info__group"
      >
        <div class="complementary-info__group__radio">
          <shared-radio
            :active="unchecked? null : optinEmail"
            :is-horizontal="isHorizontal"
            :list="radios.optin_email.list"
            :name="radios.optin_email.name"
            :label="$t('profile.byEmail')"
            :errors="errors.optin_email"
            @toggle="updateRadio"
          >
            <ul

              class="error"
            >
              <li
                class="error"
                v-if="errors.optin_email.$error"
              >
                <span>{{ $t('components.complementary_info.required') }}</span>
              </li>
              <div v-else />
            </ul>
          </shared-radio>
          <shared-radio
            :active="unchecked? null : optinSms"
            :is-horizontal="isHorizontal"
            :list="radios.optin_sms.list"
            :name="radios.optin_sms.name"
            :label="$t('profile.bySMS')"
            :errors="errors.optin_sms"
            @toggle="updateRadio"
          >
            <div
              class="error"
              v-if="errors.optin_sms.$error"
            >
              <span>{{ $t('components.complementary_info.required') }}</span>
            </div>
            <div v-else />
          </shared-radio>
        </div>
      </section>
      <div
        v-if="minified"
        class="complementary-info__minified"
      >
        <button @click="toggleMinified">
          {{ $t('profile.editPreferences') }}
        </button>
      </div>
    </div>
    <rent-button
      v-if="button && !minified"
      :loading="loading"
      @buttonclicked="submitForm()"
    >
      {{ button }}
    </rent-button>
  </section>
</template>
<script>
import SharedRadio from '../SharedRadio'
import RentButton from '../../RentButton'
// import Confidentiality from './Confidentiality'

export default {
  props: {
    errors: {
      type: Object,
      required: true,
    },
    minified: {
      type: Boolean,
      default: false,
    },
    button: {
      type: String,
      default: null,
    },
    optinEmail: {
      type: Boolean,
      default: null,
    },
    optinSms: {
      type: Boolean,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isHorizontal: {
      type: Boolean,
      default: false,
    },
    unchecked: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      radios: {
        optin_email: {
          name: 'optin_email',
          list: [
            {
              label: 'Oui',
              value: true,
            },
            {
              label: 'Non',
              value: false,
            },
          ],
          errors: [
            {
              type: 'required',
              label: '* Ce champ est requis',
            },
          ],
        },
        optin_sms: {
          name: 'optin_sms',
          list: [
            {
              label: 'Oui',
              value: true,
            },
            {
              label: 'Non',
              value: false,
            },
          ],
        },
      },
    }
  },
  components: {
    SharedRadio,
    RentButton,
    // Confidentiality,
  },
  methods: {
    updateRadio(radio) {
      return this.$emit('updatedRadioButton', radio)
    },
    submitForm() {
      this.$emit('submitForm')
    },
    toggleMinified() {
      this.$emit('toggleMinified')
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../../../../_src/sass/config/vars';
@import '../../../../../../_src/sass/config/mixins';
@import '../../../../../../_src/sass/config/responsive';

.complementary-info {
  @include shared-padding;

  background-color: $c-alabaster;
  color: $c-tundora;

  &__minified {
    button {
      background: none;
      border: none;
      color: black;
      cursor: pointer;
      font-family: $f-graphie-book;
      padding: 0;
      text-decoration: underline;
    }
  }

  &__group {
    &__radio {
      display: flex;
      flex-direction: row;

      &::v-deep .shared-radio {
        flex: 0;
        margin-right: 45px;
      }
    }
  }

  h4 {
    margin-bottom: 5px;
    margin-top: 20px;
  }

  p {
    margin: 23px 0;
  }

  .subtitle {
    color: #000;
    padding-bottom: 0;
  }

  button {
    margin-top: 20px;
  }

  .error span {
    @include errorInputs;

    text-align: right;
  }
}
</style>
